import React, { useEffect, useState } from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";

import Index from "./Pages/Index";
import Menu from "./Pages/Menu";
import Servicos from "./Pages/Servicos";
import Pastas from "./Pages/Pastas";
import CadCargo from "./Pages/CadCargo";
import CadOperador from "./Pages/CadOperador";
import CadCliente from "./Pages/CadCliente";
import VincularUsuarioProcesso from "./Pages/CadUsuarioProcesso";
import Planejamento from "./Pages/Planejamento";
import CadastroPlanejamento from "./Pages/CadPlanejamento";
import Patrimonio from "./Pages/Patrimonio";
import CadPatrimonio from "./Pages/CadPatrimonio";
import CadastroOperadorExterno from "./Pages/CadOperadorExterno";
import AprovarOperadoresExternos from "./Pages/AprovOperadorExterno";
import CadUploadEstrutura from './Pages/CadUploadEstrutura';
import VincularProcessoUsuarios from './Pages/CadProcessoUsuario';
import Auditoria from "./Pages/Auditoria/ListaClientesAuditoria";
import AuditoriaSecaoCliente from "./Pages/Auditoria/Secao";
import AuditoriaQuestao from "./Pages/Auditoria/Questao";
import AcompanhamentoQuestao from "./Pages/Auditoria/Questao/acompanhamentoQuestao";
import AuditoriaChecklist from "./Pages/Auditoria/Checklist";
import CadOperadorSecao from "./Pages/CadOperadorSecao";
import RecuperarSenhaSolicitar from "./Pages/RecuperarSenhaSolicitar";
import RecuperarSenhaConfirmar from "./Pages/RecuperarSenhaConfirmar";
import Agenda from "./Pages/Agenda";
import CadAgendaGrupo from "./Pages/CadAgendaGrupo";
import SisAuditoriaConsulta from "./Pages/SisAuditoriaConsulta";
import AssinaturaDigital from "./Pages/AssinaturaDigital";
import AssinaturaDigitalCertificado from "./Pages/AssinaturaDigitalCertificado";
import AssinaturaDigitalControleAcesso from "./Pages/AssinaturaDigitalControleAcesso";
import { assinaturaDigitalService } from "./Services/assinaturaDigital";


import { useAuthContext } from "./context/authContext";
import { operadorEhAdmin, operadorEhAdminOuGerente } from "./Utils/cargos";

const routeNames = {
  index: "/",
  menu: "/Menu",
  upload: "/Upload",
  Servicos: "/Servicos/:IDCliente",
  Pastas: "/Pastas/:IDCliente/:IDProcesso/:IDPastaPai",
  CadCargo: "/CadCargo",
  CadOperador: "/CadOperador",
  CadCliente: "/CadCliente",
  UsuarioProcesso: "/CadOperadorProcesso",
  Planejamento: "/Planejamento/:IDCliente/:IDProcesso",
  CadPlanejamento: "/CadastroPlanejamento",
  Patrimonio: "/AuditoriaPatrimonial/:IDCliente",
  CadPatrimonio: "/CadPatrimonio/:IDCliente",
  CadExterno: "/cadexterno/:idCliente",
  AprovarOperadoresExternos: "/aprovexterno",
  CadUploadEstrutura: "/UploadEstrutura/:IDProcesso/:IDDiretorioPai/:NomeBucketAws",
  VincularProcessoUsuarios: "/CadProcessoOperador",
  Auditoria: "/Auditoria",
  AuditoriaSecaoCliente: "/AuditoriaSecao/:IDClienteAuditoria",
  AuditoriaQuestao: "/AuditoriaQuestao",
  AcompanhamentoQuestao: "/Auditoria/:IDSecao/Acompanhamento",
  AuditoriaChecklist: "/AuditoriaChecklist/:IDSecao",
  CadOperadorSecao: "/AuditoriaOperadorSecao",
  RecuperarSenha: "/recuperar-senha",
  RecuperarSenhaConfirmar: "/recuperar-senha/confirmar",
  Agenda: "/Agenda",
  CadAgendaGrupo: "/CadAgendaGrupo",
  SisAuditoriaConsulta: "/ConsultaAuditoria",
  AssinaturaDigital: "/AssinaturaDigital",
  AssinaturaDigitalCertificado: "/AssinaturaDigital/Certificado",
  AssinaturaDigitalControleAcesso: "/AssinaturaDigital/Certificado/ControleAcesso",
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, authReady } = useAuthContext();
  const location = useLocation();

  if (!authReady) return <div>Carregando...</div>;

  if (!isAuthenticated && location.pathname !== "/") {
    return <Navigate to="/" replace />;
  }

  return children;
};

const AdminGerenteRoute = ({ children }) => {
  const { operador } = useAuthContext();
  return operadorEhAdminOuGerente(operador)
    ? children
    : <Navigate to="/Menu" replace />;
};

const AdminRoute = ({ children }) => {
  const { operador } = useAuthContext();
  return operadorEhAdmin(operador) ? children : <Navigate to="/Menu" replace />;
};

const FilaAssinaturaRoute = ({ children }) => {
  const { operador } = useAuthContext();
  const [permitido, setPermitido] = useState(null);
  useEffect(() => {
    if (!operador?.IDOperador) return;
    let cancelado = false;
    setPermitido(null);
    const consultar = async () => {
      try {
        const acesso = await assinaturaDigitalService.buscarMeuAcesso();
        if (!cancelado) setPermitido(acesso.podeAcessarFila === true);
      } catch (_error) {
        if (!cancelado) setPermitido(false);
      }
    };
    consultar();
    const intervalo = window.setInterval(consultar, 30000);
    return () => { cancelado = true; window.clearInterval(intervalo); };
  }, [operador?.IDOperador]);
  if (permitido === null) return <div>Verificando acesso...</div>;
  return permitido ? children : <Navigate to="/Menu" replace />;
};

const Rotas = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota pública: Login */}
        <Route path={routeNames.index} element={<Index />} />
        <Route path={routeNames.CadExterno} element={<CadastroOperadorExterno />} />
        <Route path={routeNames.RecuperarSenha} element={<RecuperarSenhaSolicitar />} />
        <Route path={routeNames.RecuperarSenhaConfirmar} element={<RecuperarSenhaConfirmar />} />


        {/* Rotas protegidas */}
        <Route path={routeNames.menu} element={<ProtectedRoute> <Menu /> </ProtectedRoute>} />
        <Route path={routeNames.Servicos} element={<ProtectedRoute> <Servicos /></ProtectedRoute>} />
        <Route path={routeNames.Pastas} element={<ProtectedRoute> <Pastas /> </ProtectedRoute>} />
        <Route path={routeNames.CadCargo} element={<ProtectedRoute><AdminRoute><CadCargo /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.CadOperador} element={<ProtectedRoute><AdminGerenteRoute><CadOperador /></AdminGerenteRoute></ProtectedRoute>} />
        <Route path={routeNames.CadCliente} element={<ProtectedRoute><AdminRoute><CadCliente /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.CadPlanejamento} element={<ProtectedRoute><AdminRoute><CadastroPlanejamento /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.UsuarioProcesso} element={<ProtectedRoute><AdminRoute><VincularUsuarioProcesso /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.Planejamento} element={<ProtectedRoute> <Planejamento /> </ProtectedRoute>} />
        <Route path={routeNames.Patrimonio} element={<ProtectedRoute> <Patrimonio /> </ProtectedRoute>} />
        <Route path={routeNames.CadPatrimonio} element={<ProtectedRoute> <CadPatrimonio /> </ProtectedRoute>} />
        <Route path={routeNames.AprovarOperadoresExternos} element={<ProtectedRoute><AdminRoute><AprovarOperadoresExternos /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.CadUploadEstrutura} element={<ProtectedRoute> <CadUploadEstrutura /> </ProtectedRoute>} />
        <Route path={routeNames.VincularProcessoUsuarios} element={<ProtectedRoute><AdminRoute><VincularProcessoUsuarios /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.Auditoria} element={<ProtectedRoute> <Auditoria /> </ProtectedRoute>} />
        <Route path={routeNames.AuditoriaSecaoCliente} element={<ProtectedRoute> <AuditoriaSecaoCliente /> </ProtectedRoute>} />
        <Route path={routeNames.AuditoriaQuestao} element={<ProtectedRoute><AuditoriaQuestao /></ProtectedRoute>} />
        <Route path="/AuditoriaQuestao/:modelo" element={<ProtectedRoute><AuditoriaQuestao /></ProtectedRoute>} />
        <Route path="/AuditoriaQuestao/:IDSecao/:modelo" element={<ProtectedRoute><AuditoriaQuestao /></ProtectedRoute>} />
        <Route path={routeNames.AcompanhamentoQuestao} element={<ProtectedRoute><AcompanhamentoQuestao /></ProtectedRoute>} />
        <Route path={routeNames.AuditoriaChecklist} element={<ProtectedRoute><AuditoriaChecklist /></ProtectedRoute>} />
        <Route path={routeNames.CadOperadorSecao} element={<ProtectedRoute><CadOperadorSecao /></ProtectedRoute>} />
        <Route path={routeNames.Agenda} element={<ProtectedRoute><Agenda /></ProtectedRoute>} />
        <Route path={routeNames.CadAgendaGrupo} element={<ProtectedRoute><AdminRoute><CadAgendaGrupo /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.SisAuditoriaConsulta} element={<ProtectedRoute><AdminRoute><SisAuditoriaConsulta /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.AssinaturaDigital} element={<ProtectedRoute><FilaAssinaturaRoute><AssinaturaDigital /></FilaAssinaturaRoute></ProtectedRoute>} />
        <Route path={routeNames.AssinaturaDigitalCertificado} element={<ProtectedRoute><AdminRoute><AssinaturaDigitalCertificado /></AdminRoute></ProtectedRoute>} />
        <Route path={routeNames.AssinaturaDigitalControleAcesso} element={<ProtectedRoute><AdminRoute><AssinaturaDigitalControleAcesso /></AdminRoute></ProtectedRoute>} />

      </Routes>
    </BrowserRouter>
  );
};

export default Rotas;
